import { render, staticRenderFns } from "./CustomerReport.vue?vue&type=template&id=273d3416&scoped=true"
import script from "./CustomerReport.vue?vue&type=script&lang=js"
export * from "./CustomerReport.vue?vue&type=script&lang=js"
import style0 from "./CustomerReport.vue?vue&type=style&index=0&id=273d3416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273d3416",
  null
  
)

export default component.exports